// extracted by mini-css-extract-plugin
export default {"box1":"cart_box1__qqTWi","tops":"cart_tops__Os+QP","btn":"cart_btn__O-Cv4"};